// CSS Modules - component class name prefix: Locations__

<template>
  <div :class="$style.container">
    <div :class="$style.contentArea">
      <MapFilterApp
        :config="config.mapConfig"
        :state="state"
        @displayDetails="getContentFromUrl"
      />
    </div>
    <template v-if="jsonLoaded">
      <h2 v-if="json.title" :class="$style.title">
        {{ json.title }}
      </h2>
      <div :class="$style.contentArea">
        <section v-if="json.content.simpleMap" :class="$style.contentSection">
          <ZoomableMapBox :config="json.content.simpleMap" />
        </section>
        <section v-if="json.content.generalInfo" :class="$style.contentSection">
          <TextMediaElement
            :mediaRight="json.content.generalInfo.mediaRight"
            :text="json.content.generalInfo.text"
            :title="json.content.generalInfo.title"
            :slides="json.content.generalInfo.slides"
            :video="json.content.generalInfo.video"
            :image="json.content.generalInfo.image"
          />
        </section>
        <section
          v-if="json.content.benefits"
          :class="[$style.contentSection, $style.benefits]"
        >
          <IconsList :config="json.content.benefits" />
        </section>
		 <section v-if="json.content.hero" :class="$style.contentSection">
          <h2>{{ json.content.hero.title }}</h2>
          <div
            v-if="json.content.hero.text"
            v-html="json.content.hero.text"
            :class="$style.contentText"
          ></div>
          <HeroSlider :slides="json.content.hero.slides" />
        </section>
        <section v-if="json.content.wayToUs" :class="$style.contentSection">
          <TextMediaElement
            :mediaRight="json.content.wayToUs.mediaRight"
            :title="json.content.wayToUs.title"
            :text="json.content.wayToUs.text"
            :slides="json.content.wayToUs.slides"
            :video="json.content.wayToUs.video"
            :image="json.content.wayToUs.image"
          />
        </section>
        <section v-if="json.content.carousel" :class="$style.contentSection">
          <h2>{{ json.content.carousel.title }}</h2>
          <div
            v-if="json.content.carousel.text"
            v-html="json.content.carousel.text"
            :class="$style.contentText"
          ></div>
          <RotatingCarousel
            uid="locationCarousel"
            :slides="json.content.carousel.slides"
            :autoplay="true"
            :bgImgUrl="json.content.carousel.bgImgUrl"
          />
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import MapFilterApp from "../MapFilterApp/MapFilterApp.vue";
import ZoomableMapBox from "../ZoomableMapBox/ZoomableMapBox.vue";
import IconsList from "../IconsList/IconsList.vue";
import HeroSlider from "../HeroSlider/HeroSlider.vue";
import TextMediaElement from "../TextMediaElement/TextMediaElement.vue";
import RotatingCarousel from "../RotatingCarousel/RotatingCarousel.vue";
import axios from "axios";

export default {
  name: "Locations",
  components: {
    MapFilterApp,
    ZoomableMapBox,
    IconsList,
    HeroSlider,
    TextMediaElement,
    RotatingCarousel
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    state: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      json: null,
      jsonLoaded: false
    };
  },
  methods: {
    getContentFromUrl(url) {
      axios
        .get(url)
        .then(
          response => ((this.json = response.data), (this.jsonLoaded = true))
        )
        .catch(
          error => (
            console.error(error), (this.json = null), (this.jsonLoaded = false)
          )
        );
    }
  }
};
</script>

<style module lang="scss">
@import "./Locations.scss";
</style>
